// src/stone/icons/Shop2.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Shop2 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 22",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 10,
          strokeWidth: 2,
          d: "M4 10v11h16V10M4 1 1 6a2.992 2.992 0 0 0 5.667 1.347 2.977 2.977 0 0 0 5.333 0 2.977 2.977 0 0 0 5.333 0A2.992 2.992 0 0 0 23 6l-3-5z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 10,
          strokeWidth: 2,
          d: "M10 21v-6h4v6"
        }
      )
    ]
  }
);
var Shop2_default = Shop2;

export {
  Shop2_default
};
